import SkeletonBox from '@/components/atoms/SkeletonBox/SkeletonBox';
import ContentBlock from '@/components/molecules/ContentBlock';

import styles from './LiceReportSkeleton.module.scss';

const SKELETON_ROW_KEYS = ['row-1', 'row-2', 'row-3', 'row-4', 'row-5'] as const;

export default function LiceReportSkeleton() {
    return (
        <ContentBlock spacing="none">
            <div className={styles.skeletonHeader}>
                <SkeletonBox width={220} height={24} />
                <SkeletonBox width={120} height={36} />
            </div>
            <div className={styles.skeletonTable}>
                <SkeletonBox width="35%" height={20} />
                {SKELETON_ROW_KEYS.map((key) => (
                    <SkeletonBox key={key} width="100%" height="5rem" />
                ))}
            </div>
        </ContentBlock>
    );
}
